import React from 'react';
import styled from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const SectionRow = styled(Common.FlexRow)`
	flex-wrap: wrap;
	row-gap: 0.1rem;
	column-gap: 0.5rem;
	align-items: start;
`;

export const Bold = styled(Common.Bold)``;

export const InputGroup = styled(Common.InputGroup).attrs((props) => ({
	style: {
		flexBasis: 'calc(50% - 1rem)',
		rowGap: '0.15rem',
	},
}))``;

export const Select = styled(Common.Select)``;

export const SelectTitle = styled(Common.SelectTitle)``;

export const MenuItem = styled(Common.MenuItem)``;
